module.exports = __webpack_public_path__ + "img/wenzhangfengmian.ad9edea9.png";